import queryKeys from '@/constants/queryKeys';
import { getMyOrganizationMemberCares } from '@/services/api/requests/member-care';
import { useAppStore } from '@/store/useAppStore';
import { useInfinitePagination } from '../useInfinitePagination';
import { TMemberCare } from '@/types/MemberCare.types';
import { INFINITE_SCROLL_CARDS_PER_PAGE } from '@/constants';

const useOrganizationMemberCares = (starredFirst = false) => {
  const { user } = useAppStore();

  return useInfinitePagination<TMemberCare[]>({
    query: (page, limit) => getMyOrganizationMemberCares(page, limit, starredFirst),
    queryKey: [queryKeys.memberCare.myOrganizationMemberCares, user?.email ?? '', String(starredFirst)],
    limit: INFINITE_SCROLL_CARDS_PER_PAGE,
    getId: (member) => member.user_id,
  });
};

export default useOrganizationMemberCares;
